import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import OfferStats from './OfferStats';
import TaskListContainer from 'features/tasks/components/TaskListContainer';
import { loadActiveContractChartData, loadAverageTimeStates, loadOfferStats } from 'actions/actionCreators/dashboardActions';
import ActiveContractChart from './averagecharts/ActiveContractChart';
import AverageTimeStatesChart from './averagecharts/AverageTimeStatesChart';
import HeaderPortal from '../layout/HeaderPortal';
import DashboardIndicatorsContainer from 'features/dashboardIndicators/components/DashboardIndicatorsContainer';
import { useUserData } from 'customHooks/rights';
import { emptyObject } from 'constants/emptyConst';
import { isEmpty, head } from 'ramda';
import { GlobalRightsContext } from 'providers/GlobalRightsContext';

const Dashboard = ({ history }) => {
  const { dashboardTasksRead, dashboardRead } = useContext(GlobalRightsContext);
  const dispatch = useDispatch();
  const { offerStatsData, averageTimeStates, activeContractChartData } = useSelector(state => state.dashboard, shallowEqual);
  const user = useSelector(state => state?.oidc?.user || emptyObject, shallowEqual);

  useEffect(() => {
    dispatch(loadActiveContractChartData(false));
    dispatch(loadAverageTimeStates(false));
    dispatch(loadOfferStats(false));
  }, [dispatch]);

  const { userData } = useUserData(user);
  const dashboardData = userData && (userData?.userGroups?.filter(userGroup => !isEmpty(userGroup.dashboardIds)) |> head);

  return (
    <>
      {dashboardRead && <OfferStats data={offerStatsData} />}

      {dashboardRead && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            {activeContractChartData && (
              <ActiveContractChart
                activeContractChartData={activeContractChartData}
                loadActiveContractChartData={() => dispatch(loadActiveContractChartData(true))}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            {averageTimeStates && (
              <AverageTimeStatesChart
                averageTimeStatesData={averageTimeStates}
                loadAverageTimeStates={() => dispatch(loadAverageTimeStates(true))}
              />
            )}
          </Grid>
        </Grid>
      )}
      <Grid container spacing={2}>
        {dashboardData && (
          <Grid item xs={12}>
            <DashboardIndicatorsContainer
              userId={userData?.id}
              groupName={dashboardData?.name}
              dashboardIds={dashboardData?.dashboardIds}
            />
          </Grid>
        )}
      </Grid>
      {dashboardTasksRead && (
        <Grid container spacing={2} mt={0}>
          <Grid item xs={12}>
            <TaskListContainer pushHistory={history.push} />
          </Grid>
        </Grid>
      )}
      <HeaderPortal />
    </>
  );
};

Dashboard.propTypes = {
  history: PropTypes.object.isRequired
};

export default Dashboard;
